import { render, staticRenderFns } from "./MgmAwards.vue?vue&type=template&id=f6a4f1a0&scoped=true&"
import script from "./MgmAwards.vue?vue&type=script&lang=js&"
export * from "./MgmAwards.vue?vue&type=script&lang=js&"
import style0 from "./MgmAwards.vue?vue&type=style&index=0&id=f6a4f1a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a4f1a0",
  null
  
)

export default component.exports